import { render, staticRenderFns } from "./TransactionMatching.vue?vue&type=template&id=2c088b39&"
import script from "./TransactionMatching.vue?vue&type=script&lang=ts&"
export * from "./TransactionMatching.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports